export default "__VITE_ASSET__B$usTIAm__"